import * as React from 'react'

import { runInAction } from 'mobx'
import { observer } from 'mobx-react'

import { IStartClosureActionLocationMap } from '~/client/graph/types.generated'
import { NOOP } from '~/client/src/shared/utils/noop'

import { IFieldArgumentOption } from '../../WorkflowActionConfigurator.store'
import ActionFieldSelector from '../ActionFieldSelector'
import RestrictionButton from './RestrictionButton'

// localization: no text to translate

interface IProps {
  actionArgumentOptions: IFieldArgumentOption[]
  locationFieldsMap?: IStartClosureActionLocationMap[]

  onMapChange(locationFieldsMap: IStartClosureActionLocationMap[]): void
}

@observer
export default class ClosureStartSelector extends React.Component<IProps> {
  public render() {
    const selectedFieldIds =
      this.props.locationFieldsMap?.reduce((list, value) => {
        if (!value.isDisabled) {
          list.push(value.fieldId)
        }
        return list
      }, [] as string[]) || []

    return (
      <ActionFieldSelector
        stepActionFieldIds={selectedFieldIds}
        actionArgumentOptions={this.props.actionArgumentOptions}
        onChange={NOOP}
        renderTrailingContent={this.renderTrailingContent}
        onCheckboxClick={this.handleCheckboxClick}
        isCheckboxChecked={this.isCheckboxChecked}
      />
    )
  }

  private renderTrailingContent = (
    option: IFieldArgumentOption,
  ): JSX.Element => {
    const { field } = option

    if (!field) return null

    const workflowTypes =
      this.props.locationFieldsMap?.find(item => item.fieldId === field.id)
        ?.specifiedPermitTypes || []

    return (
      <div className="row relative mr8">
        <RestrictionButton
          fieldId={field.id}
          workflowTypes={workflowTypes}
          onChange={this.handleWorkflowRestrictionChange}
        />
      </div>
    )
  }

  private handleCheckboxClick = (option: IFieldArgumentOption) => {
    const fieldId = option.field?.id
    if (!fieldId) return

    const map = [...(this.props.locationFieldsMap || [])]
    const existingItem = map.find(item => item.fieldId === fieldId)

    runInAction(() => {
      if (existingItem) {
        existingItem.isDisabled = !existingItem.isDisabled
      } else {
        map.push({
          fieldId,
          specifiedPermitTypes: [],
          isDisabled: false,
        })
      }
    })

    this.props.onMapChange(map)
  }

  private isCheckboxChecked = (option: IFieldArgumentOption): boolean => {
    const fieldId = option.field?.id
    if (!fieldId) return false

    const item = this.props.locationFieldsMap?.find(
      mapItem => mapItem.fieldId === fieldId,
    )
    return !!item && !item.isDisabled
  }

  private handleWorkflowRestrictionChange = (
    fieldId: string,
    workflowTypes: string[],
  ) => {
    const map = (this.props.locationFieldsMap || []).filter(item =>
      this.props.actionArgumentOptions.some(
        option => option.field?.id === item.fieldId,
      ),
    )
    const existingItem = map.find(item => item.fieldId === fieldId)

    runInAction(() => {
      if (existingItem) {
        existingItem.specifiedPermitTypes = workflowTypes
      } else {
        map.push({
          fieldId,
          specifiedPermitTypes: workflowTypes,
          isDisabled: !existingItem,
        })
      }
    })

    this.props.onMapChange(map)
  }
}
